import { render, staticRenderFns } from "./cloudList.vue?vue&type=template&id=56cd527c&scoped=true&"
import script from "./cloudList.vue?vue&type=script&lang=js&"
export * from "./cloudList.vue?vue&type=script&lang=js&"
import style0 from "./cloudList.vue?vue&type=style&index=0&id=56cd527c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd527c",
  null
  
)

export default component.exports